'use client';

import React, { useEffect, useState } from 'react';

interface ClientOnlyProps {
  /** 插槽内容 */
  children: React.ReactNode;
}

export default function ClientOnly({ children }: ClientOnlyProps) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted ? <>{children}</> : null;
}
